import React, { Component } from "react";
import { Form, Col, Container } from "react-bootstrap";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import gql from "graphql-tag";
import * as Cookies from "es-cookie";
import { withApollo } from "react-apollo";
import { withRouter } from "react-router-dom";
import { graphql } from "react-apollo";
import * as compose from "lodash.flowright";
import "./_admissionForms.scss";

// ── GQL Mutations ────────────────────────────────────────────
const ADD_ENQUIRY_FORM_DETAILS = gql`
  mutation ($params: ManageEnquiryFieldsInput!) {
    manageEnquiryFormFields(params: $params)
  }
`;

// removed CREATE_CUSTOM_FORM_FIELD mutation as it is no longer used

const GET_ENQUIRY_FORMS = gql`
  query ($institute_id: Int!, $branch_id: String!) {
    getEnquiryForms(institute_id: $institute_id, branch_id: $branch_id) {
      id
      form_name
    }
  }
`;

// ── Helpers ──────────────────────────────────────────────────
const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
};

// ── Helper: Title case field names ──────────────────────────
const toTitleCase = (str) => {
  return str
    .trim()
    .toLowerCase()
    .split(/\s+/)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

// ── Constants ────────────────────────────────────────────────
const FIELD_TYPES = {
  TEXT: { id: 1, label: "Text" },
  TEXTAREA: { id: 2, label: "Textarea" },
  NUMBER: { id: 3, label: "Number" },
  DROPDOWN: { id: 4, label: "Dropdown" },
  RADIO: { id: 5, label: "Radiobutton" },
  DATE: { id: 6, label: "Date" },
  CHECKBOX: { id: 7, label: "Checkbox" }, // ← ADDED
};

const FIELD_SECTIONS = {
  PERSONAL: "Personal Details",
  FAMILY: "Family Details",
  COMMUNICATION: "Address & Communication",
  ACADEMIC: "Academic Details",
};

const FIELD_MAPPING = {
  "student name": FIELD_SECTIONS.PERSONAL,
  gender: FIELD_SECTIONS.PERSONAL,
  "date of birth": FIELD_SECTIONS.PERSONAL,
  dob: FIELD_SECTIONS.PERSONAL,
  "student mobile": FIELD_SECTIONS.PERSONAL,
  "student email": FIELD_SECTIONS.PERSONAL,
  email: FIELD_SECTIONS.PERSONAL,
  aadhaar: FIELD_SECTIONS.PERSONAL,
  "aadhaar number": FIELD_SECTIONS.PERSONAL,
  "blood group": FIELD_SECTIONS.PERSONAL,
  mobile: FIELD_SECTIONS.PERSONAL,
  name: FIELD_SECTIONS.PERSONAL,
  "father name": FIELD_SECTIONS.FAMILY,
  "mother name": FIELD_SECTIONS.FAMILY,
  "guardian name": FIELD_SECTIONS.FAMILY,
  "father mobile": FIELD_SECTIONS.FAMILY,
  "father occupation": FIELD_SECTIONS.FAMILY,
  father_name: FIELD_SECTIONS.FAMILY,
  mother_name: FIELD_SECTIONS.FAMILY,
  "permanent address": FIELD_SECTIONS.COMMUNICATION,
  city: FIELD_SECTIONS.COMMUNICATION,
  state: FIELD_SECTIONS.COMMUNICATION,
  pincode: FIELD_SECTIONS.COMMUNICATION,
  address: FIELD_SECTIONS.COMMUNICATION,
  "previous school": FIELD_SECTIONS.ACADEMIC,
  "last class attended": FIELD_SECTIONS.ACADEMIC,
  board: FIELD_SECTIONS.ACADEMIC,
  class: FIELD_SECTIONS.ACADEMIC,
  school: FIELD_SECTIONS.ACADEMIC,
};

// ── Component ────────────────────────────────────────────────
class CreateAdmissionFormPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      branch_id: "",
      branchError: "",
      form_name: "",
      formNameError: "",
      formSelectedValue: [],
      defaultSelectedValue: [],
      selectedFieldTypes: {},
      selectedFieldOptions: {},
      optionInputValues: {},
      selectableFields: [],
      loadingSpinner: false,
      submitError: "",
      submitSuccess: false,
      dataClear: 0,
      existing_form_field_id: 0,
      isEditMode: false,
      isDisabled: false,
      // ── Custom field state ───────────────
      customFieldSearch: "", // for filtering the field list
      customCreateName: "", // for the independent create panel
      customCreateType: FIELD_TYPES.TEXT.id,
      customCreateError: "",
      customFieldSearchError: "",
      isCreatingField: false,
      // ── Create field modal ────────────────
      isCreateFieldModalOpen: false,
      createFieldInput: "",
      createFieldError: "",
    };
  }

  componentDidMount() {
    this.initModalState();
  }

  componentDidUpdate(prevProps) {
    if (this.props.stateData !== prevProps.stateData || 
        (this.props.globals?.globalBranches !== prevProps.globals?.globalBranches && (!this.state.branch_id || this.state.branch_id === "null"))) {
      this.initModalState();
    }
  }

  initModalState = async () => {
    const { getEnquiryFormFields, stateData } = this.props;
    const defaultFields = [];
    const selectableFields = [];
    const defaultFieldTypes = {};

    const processField = (obj) => {
      const label = obj.label.toLowerCase();
      let typeId = FIELD_TYPES.TEXT.id;
      if (label.includes("date") || label.includes("dob"))
        typeId = FIELD_TYPES.DATE.id;
      else if (
        label.includes("address") ||
        label.includes("comment") ||
        label.includes("background")
      )
        typeId = FIELD_TYPES.TEXTAREA.id;
      else if (
        label.includes("mobile") ||
        label.includes("number") ||
        label.includes("students") ||
        label.includes("id")
      )
        typeId = FIELD_TYPES.NUMBER.id;
      else if (
        label.includes("gender") ||
        label.includes("status") ||
        label.includes("sex")
      )
        typeId = FIELD_TYPES.RADIO.id;
      else if (
        label.includes("branch") || 
        label.includes("class") || 
        label.includes("course")
      )
        typeId = FIELD_TYPES.DROPDOWN.id;
      defaultFieldTypes[obj.id] = typeId;
      return obj;
    };

    // Auto-set default options for known fields
    const seedDefaultOptions = (obj, typeId) => {
      const label = obj.label.toLowerCase();
      const opts = {};
      if (label.includes("gender") || label.includes("sex")) {
        opts[obj.id] = ["Male", "Female", "Others"];
      } else if (label.includes("status")) {
        opts[obj.id] = ["Active", "Inactive"];
      }
      return opts;
    };

    const allFields =
      getEnquiryFormFields && getEnquiryFormFields.getEnquiryFormFields
        ? getEnquiryFormFields.getEnquiryFormFields
        : [];

    let foundCourse = false;

    allFields.forEach((item) => {
      if (
        !item ||
        !item.field_name ||
        item.id === null ||
        item.id === undefined
      )
        return;
      const originalLabel = item.field_name.toLowerCase();
      const obj = {
        value: item.id,
        label: item.field_name,
        id: item.id.toString(),
      };

      // Ensure only ONE "Course Name" field exists, rename the first, hide the rest
      if (
        originalLabel.includes("course") ||
        originalLabel.includes("courses")
      ) {
        if (!foundCourse) {
          foundCourse = true;
          obj.label = "Course Name";
        } else {
          return;
        }
      }

      const label = obj.label.toLowerCase().trim();
      const isMandatory =
        item.id == 1 ||
        item.id == 2 ||
        label === "name" ||
        label === "student name" ||
        label === "mobile" ||
        label === "mobile number" ||
        label === "student mobile" ||
        label.includes("email") ||
        label.includes("gender") ||
        label === "date of birth" ||
        label === "dob" ||
        label === "course name";
      if (isMandatory) {
        const processed = processField(obj);
        defaultFields.push(processed);
        // Seed options for radio/dropdown default fields
        const auto = seedDefaultOptions(
          processed,
          defaultFieldTypes[processed.id],
        );
        if (auto[processed.id]) {
          // merged later into selectedFieldOptions
          defaultFieldTypes[`__opts_${processed.id}`] = auto[processed.id];
        }
      } else {
        selectableFields.push(processField(obj));
      }
    });

    const isEditMode = stateData?.existingAdmissionFormFields?.length > 0;
    let formSelectedValue = [];
    let branch_id = "";
    let form_name = "";
    let existing_form_field_id = 0;
    // Extract seeded default options out of the type map
    const seededOptions = {};
    Object.keys(defaultFieldTypes).forEach((k) => {
      if (k.startsWith("__opts_")) {
        const realId = k.replace("__opts_", "");
        seededOptions[realId] = defaultFieldTypes[k];
        delete defaultFieldTypes[k];
      }
    });
    let selectedFieldTypes = { ...defaultFieldTypes };
    let selectedFieldOptions = { ...seededOptions };

    if (isEditMode) {
      const existing = stateData.existingAdmissionFormFields[0];
      const defaultIds = defaultFields.map((f) => f.id.toString());
      const formIdToFetch = existing.existing_form_field_id || existing.id || 0;

      this.setState({ loadingSpinner: true });

      let savedFields = [];
      try {
        const result = await this.props.client.query({
          query: gql`
            query ($form_id: Int!) {
              getEnquiryFormFields(form_id: $form_id) {
                id
                field_name
                field_type_id
                options
              }
            }
          `,
          variables: { form_id: parseInt(formIdToFetch) },
          fetchPolicy: "network-only",
        });
        savedFields = result.data.getEnquiryFormFields || [];
      } catch (e) {
        console.error("Error fetching saved fields directly", e);
      }

      savedFields.forEach((field) => {
        if (!field || !field.field_name) return;
        const matchingName = field.field_name.toString().trim().toLowerCase();
        const found = allFields.find(
          (f) => f.field_name && f.field_name.toString().trim().toLowerCase() === matchingName
        );

        if (found && found.id !== null && found.id !== undefined) {
          const idStr = found.id.toString();
          if (!defaultIds.includes(idStr)) {
            formSelectedValue.push(
              processField({
                label: found.field_name,
                value: found.id,
                id: idStr,
              }),
            );
          }
          if (field.field_type_id) {
            selectedFieldTypes[idStr] = parseInt(field.field_type_id);
          }
          if (field.options) {
            let optionsRaw = field.options;
            if (typeof optionsRaw === 'string') {
              try {
                optionsRaw = JSON.parse(optionsRaw);
              } catch (e) {
                optionsRaw = optionsRaw.split(",");
              }
            }
            if (Array.isArray(optionsRaw)) {
              selectedFieldOptions[idStr] = optionsRaw.filter(
                (o) => typeof o === 'string' && o.trim() !== ""
              );
            }
          }
        } else {
          // It's a custom field!
          const customId = "custom_" + field.id;
          formSelectedValue.push({
            label: field.field_name,
            value: customId,
            id: customId
          });
          if (field.field_type_id) {
            selectedFieldTypes[customId] = parseInt(field.field_type_id);
          }
          if (field.options) {
            let optionsRaw = field.options;
            if (typeof optionsRaw === 'string') {
              try {
                optionsRaw = JSON.parse(optionsRaw);
              } catch (e) {
                optionsRaw = optionsRaw.split(",");
              }
            }
            if (Array.isArray(optionsRaw)) {
              selectedFieldOptions[customId] = optionsRaw.filter(
                (o) => typeof o === 'string' && o.trim() !== ""
              );
            }
          }
        }
      });

      branch_id = stateData.branch_id || "";
      form_name = existing.form_name || "";
      existing_form_field_id = existing_form_field_id || 0;
    } else {
      branch_id = stateData.branch_id || "";
      if (!branch_id) {
        let authIds = [];
        try {
          const cookie = Cookies.get("branch_id");
          const parsed = cookie ? JSON.parse(cookie) : [];
          authIds = Array.isArray(parsed) ? parsed : [parsed];
        } catch (e) {
          try {
            const cookie = Cookies.get("branch_id");
            authIds = cookie ? cookie.split(",").map(id => id.trim()) : [];
          } catch (err) { console.error(err); }
        }
        authIds = authIds.map(String);

        const authorizedBranches = this.props.globals?.globalBranches?.filter(b => 
          authIds.includes("all") || authIds.includes(String(b.id))
        );

        if (authorizedBranches && authorizedBranches.length > 0) {
          branch_id = String(authorizedBranches[0].id);
        } else if (this.props.globals?.globalBranches?.length > 0) {
          branch_id = String(this.props.globals.globalBranches[0].id);
        }
      }
    }

    this.setState({
      branch_id,
      branchError: "",
      form_name,
      formNameError: "",
      formSelectedValue,
      defaultSelectedValue: defaultFields,
      selectedFieldTypes,
      selectedFieldOptions,
      optionInputValues: {},
      selectableFields,
      loadingSpinner: false,
      submitError: "",
      submitSuccess: false,
      dataClear: 1,
      existing_form_field_id,
      isEditMode,
      isDisabled: isEditMode,
      // ── Reset custom field state on re-init ──
      customFieldSearch: "",
      customCreateName: "",
      customCreateType: FIELD_TYPES.TEXT.id,
      customCreateError: "",
      customFieldSearchError: "",
      isCreatingField: false,
      // ── Reset create field modal on re-init ──
      isCreateFieldModalOpen: false,
      createFieldInput: "",
      createFieldError: "",
    });
  };

  // ── Field Type ───────────────────────────────────────────────
  handleTypeChange = (fieldId, typeId) => {
    this.setState((prevState) => ({
      selectedFieldTypes: {
        ...prevState.selectedFieldTypes,
        [fieldId]: parseInt(typeId),
      },
    }));
  };

  // ── Options Builder ──────────────────────────────────────────
  handleOptionInputChange = (fieldId, value) => {
    this.setState((prev) => ({
      optionInputValues: { ...prev.optionInputValues, [fieldId]: value },
    }));
  };

  handleAddOption = (fieldId, e = null) => {
    if (e && e.key !== "Enter") return;
    if (e) e.preventDefault();
    const { optionInputValues, selectedFieldOptions } = this.state;
    const val = (optionInputValues[fieldId] || "").trim();
    if (val) {
      const currentOptions = selectedFieldOptions[fieldId] || [];
      if (!currentOptions.includes(val)) {
        this.setState((prev) => ({
          selectedFieldOptions: {
            ...prev.selectedFieldOptions,
            [fieldId]: [...currentOptions, val],
          },
          optionInputValues: { ...prev.optionInputValues, [fieldId]: "" },
        }));
      } else {
        this.setState((prev) => ({
          optionInputValues: { ...prev.optionInputValues, [fieldId]: "" },
        }));
      }
    }
  };

  handleRemoveOption = (fieldId, idx) => {
    this.setState((prev) => {
      const currentOptions = [...(prev.selectedFieldOptions[fieldId] || [])];
      currentOptions.splice(idx, 1);
      return {
        selectedFieldOptions: {
          ...prev.selectedFieldOptions,
          [fieldId]: currentOptions,
        },
      };
    });
  };

  // ── Form Fields ──────────────────────────────────────────────
  handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "form_name") {
      this.setState({ form_name: value, formNameError: "", submitError: "" });
    } else if (name === "branch_id") {
      this.setState({ branch_id: value, branchError: "", submitError: "" });
    } else {
      this.setState({ [name]: value, [`${name}Error`]: "", submitError: "" });
    }
  };

  getSectionPrefix = (fieldName) => {
    if (!fieldName) return FIELD_SECTIONS.PERSONAL;
    const lower = fieldName.toLowerCase();
    if (FIELD_MAPPING[lower]) return FIELD_MAPPING[lower];
    if (
      lower.includes("father") ||
      lower.includes("mother") ||
      lower.includes("guardian")
    )
      return FIELD_SECTIONS.FAMILY;
    if (
      lower.includes("address") ||
      lower.includes("city") ||
      lower.includes("state") ||
      lower.includes("pincode")
    )
      return FIELD_SECTIONS.COMMUNICATION;
    if (
      lower.includes("school") ||
      lower.includes("class") ||
      lower.includes("board") ||
      lower.includes("academic")
    )
      return FIELD_SECTIONS.ACADEMIC;
    return FIELD_SECTIONS.PERSONAL;
  };

  toggleField = (field) => {
    const { formSelectedValue } = this.state;
    const index = formSelectedValue.findIndex((f) => f.id === field.id);
    if (index > -1) {
      const updated = [...formSelectedValue];
      updated.splice(index, 1);
      this.setState({ formSelectedValue: updated, submitError: "" });
    } else {
      this.setState({
        formSelectedValue: [...formSelectedValue, field],
        submitError: "",
      });
    }
  };

  // ── Custom Field — now uses independent customCreateName state ──
  handleCreateOrAddField = async () => {
    const {
      customCreateName,
      customCreateType,
      selectableFields,
      defaultSelectedValue,
      formSelectedValue,
    } = this.state;

    const trimmed = customCreateName.trim();

    // Validate
    if (!trimmed) {
      this.setState({ customCreateError: "Please enter a field name." });
      return;
    }
    if (trimmed.length < 2) {
      this.setState({
        customCreateError: "Field name must be at least 2 characters.",
      });
      return;
    }
    if (!/^[a-zA-Z0-9 _\-]+$/.test(trimmed)) {
      this.setState({
        customCreateError:
          "Only letters, numbers, spaces, underscores and hyphens are allowed.",
      });
      return;
    }

    // Check if field already exists in known pool
    const allKnown = [...defaultSelectedValue, ...selectableFields];
    const match = allKnown.find(
      (f) => f.label.toLowerCase() === trimmed.toLowerCase(),
    );

    if (match) {
      // Already in DB pool — just select it
      const alreadySelected = formSelectedValue.some((f) => f.id === match.id);
      if (!alreadySelected) {
        this.setState((prev) => ({
          formSelectedValue: [...prev.formSelectedValue, match],
          selectedFieldTypes: {
            ...prev.selectedFieldTypes,
            [match.id]: parseInt(customCreateType),
          },
          customCreateName: "",
          customCreateError: "",
        }));
      } else {
        this.setState({
          customCreateError: `"${trimmed}" is already added to the form.`,
        });
      }
      return;
    }

    // Not found → Just add it to selectableFields and formSelectedValue with temp ID
    this.setState({ isCreatingField: true, customCreateError: "" });
    try {
      const tempId = "custom_" + Date.now();
      const fieldObj = {
        id: tempId,
        value: tempId,
        label: trimmed,
      };

      this.setState((prev) => ({
        selectableFields: [...prev.selectableFields, fieldObj],
        formSelectedValue: [...prev.formSelectedValue, fieldObj],
        selectedFieldTypes: {
          ...prev.selectedFieldTypes,
          [fieldObj.id]: parseInt(customCreateType),
        },
        customCreateName: "",
        isCreatingField: false,
      }));
    } catch (err) {
      this.setState({
        customCreateError: "Failed to create field. Please try again.",
        isCreatingField: false,
      });
    }
  };

  // ── Create Field Modal Handler ───────────────────────────────
  handleCreateFieldFromModal = async () => {
    const {
      createFieldInput,
      selectableFields,
      defaultSelectedValue,
      formSelectedValue,
    } = this.state;

    const trimmed = createFieldInput.trim();
    if (!trimmed) {
      this.setState({ createFieldError: "Field name cannot be empty." });
      return;
    }

    // Check if field already exists in known pool
    const allKnown = [...defaultSelectedValue, ...selectableFields];
    const match = allKnown.find(
      (f) => f.label.toLowerCase() === trimmed.toLowerCase(),
    );

    if (match) {
      const alreadySelected = formSelectedValue.some((f) => f.id === match.id);
      if (!alreadySelected) {
        this.setState((prev) => ({
          formSelectedValue: [...prev.formSelectedValue, match],
          selectedFieldTypes: {
            ...prev.selectedFieldTypes,
            [match.id]: FIELD_TYPES.TEXT.id,
          },
          isCreateFieldModalOpen: false,
          createFieldInput: "",
          createFieldError: "",
        }));
      } else {
        this.setState({
          createFieldError: `"${trimmed}" is already added to the form.`,
        });
      }
      return;
    }

    // Not found — Just add it natively
    this.setState({ isCreatingField: true });
    try {
      const tempId = "custom_" + Date.now();
      const fieldObj = {
        id: tempId,
        value: tempId,
        label: toTitleCase(trimmed),
      };

      this.setState((prev) => ({
        selectableFields: [...prev.selectableFields, fieldObj],
        formSelectedValue: [...prev.formSelectedValue, fieldObj],
        selectedFieldTypes: {
          ...prev.selectedFieldTypes,
          [fieldObj.id]: FIELD_TYPES.TEXT.id,
        },
        isCreateFieldModalOpen: false,
        createFieldInput: "",
        createFieldError: "",
        isCreatingField: false,
      }));
    } catch (err) {
      this.setState({
        createFieldError: "Failed to create field. Please try again.",
        isCreatingField: false,
      });
    }
  };

  // ── Drag & Drop ──────────────────────────────────────────────
  onDragEnd = (result) => {
    if (!result.destination) return;
    const reordered = reorder(
      this.state.formSelectedValue,
      result.source.index,
      result.destination.index,
    );
    this.setState({ formSelectedValue: reordered });
  };

  handleSubmit = async () => {
    const {
      branch_id,
      form_name,
      formSelectedValue,
      defaultSelectedValue,
      selectedFieldTypes,
      selectedFieldOptions,
      existing_form_field_id,
      isEditMode,
    } = this.state;

    // ── Comprehensive validation ──────────────────────────────────────
    let errors = {};
    const allFields = [...defaultSelectedValue, ...formSelectedValue];

    // Branch
    if (!branch_id && !isEditMode) {
      errors.branchError = "Please select a branch.";
    }

    // Form name
    const nameVal = form_name.trim();
    if (!nameVal) {
      errors.formNameError = "Form name is required.";
    } else if (nameVal.length < 3) {
      errors.formNameError = "Form name must be at least 3 characters.";
    } else if (!/^[a-zA-Z0-9 _\-]+$/.test(nameVal)) {
      errors.formNameError =
        "Form name may only contain letters, numbers, spaces, underscores or hyphens.";
    }

    // Options required for choice-type fields
    const choiceTypes = [
      FIELD_TYPES.DROPDOWN.id,
      FIELD_TYPES.RADIO.id,
      FIELD_TYPES.CHECKBOX.id,
    ];
    for (const f of allFields) {
      if ((f.label || "").toLowerCase() === "course name") {
        continue;
      }
      const typeId = selectedFieldTypes[f.id] || FIELD_TYPES.TEXT.id;
      if (choiceTypes.includes(parseInt(typeId))) {
        const opts = selectedFieldOptions[f.id] || [];
        if (opts.length < 2) {
          errors.submitError = `Field "${f.label}" is a choice-type (${Object.values(FIELD_TYPES).find((t) => t.id === parseInt(typeId))?.label || "choice"}) — please add at least 2 options for it in the canvas.`;
          break;
        }
      }
    }

    if (Object.keys(errors).length > 0) {
      this.setState({ ...errors });
      return;
    }
    // ─────────────────────────────────────────────────────────────────

    const allFieldNames = allFields.map((f) => f.label);
    const allFieldTypes = allFields.map(
      (f) => selectedFieldTypes[f.id] || FIELD_TYPES.TEXT.id,
    );
    const allFieldOptions = allFields.map((f) =>
      (selectedFieldOptions[f.id] || []).join(","),
    );

    let params = {};
    if (isEditMode && existing_form_field_id > 0) {
      params = {
        form_name: form_name.trim(),
        form_field_names: allFieldNames.join(","),
        form_field_types: allFieldTypes.join(","),
        form_field_options: allFieldOptions.join("|"),
        updated_by: parseInt(Cookies.get("id")),
        existing_form_field_id,
      };
    } else {
      params = {
        institute_id: parseInt(Cookies.get("institutionid")),
        branch_id: parseInt(branch_id),
        form_name: form_name.trim(),
        form_field_names: allFieldNames.join(","),
        form_field_types: allFieldTypes.join(","),
        form_field_options: allFieldOptions.join("|"),
        inserted_by: parseInt(Cookies.get("id")),
        existing_form_field_id: 0,
      };
    }

    this.setState({ loadingSpinner: true });
    try {
      await this.props.manageEnquiryFormFields({
        variables: { params },
        update: (store, { data }) => {
          if (data.manageEnquiryFormFields) {
            this.setState({ submitSuccess: true, loadingSpinner: false });
            setTimeout(() => {
              this.props.history.push("/admission-forms");
            }, 1200);
          }
        },
      });
    } catch (err) {
      const msg =
        err?.graphQLErrors?.[0]?.message ||
        "Something went wrong. Please try again.";
      this.setState({ submitError: msg, loadingSpinner: false });
    }
  };

  handleCancel = () => {
    this.props.history.push("/admission-forms");
  };

  // ── Renderers ────────────────────────────────────────────────
  renderOptionsBuilder = (fieldId) => {
    const { selectedFieldOptions, optionInputValues } = this.state;
    const options = selectedFieldOptions[fieldId] || [];
    return (
      <div className="af-tag-input-container mt-2">
        {options.map((opt, oIdx) => (
          <span key={oIdx} className="af-tag-pill">
            {opt}
            <i
              className="fas fa-times"
              onClick={() => this.handleRemoveOption(fieldId, oIdx)}
            />
          </span>
        ))}
        <input
          type="text"
          className="af-tag-input"
          placeholder={
            options.length === 0
              ? "Type option and press Enter..."
              : "Add option..."
          }
          value={optionInputValues[fieldId] || ""}
          onChange={(e) =>
            this.handleOptionInputChange(fieldId, e.target.value)
          }
          onKeyDown={(e) => this.handleAddOption(fieldId, e)}
        />
      </div>
    );
  };

  renderPage() {
    const {
      branch_id,
      branchError,
      form_name,
      formNameError,
      isDisabled,
      formSelectedValue,
      selectableFields,
      customFieldSearch,
      defaultSelectedValue,
      selectedFieldTypes,
      selectedFieldOptions,
      submitError,
      loadingSpinner,
      submitSuccess,
      isEditMode,
      // independent create panel state
      customCreateName,
      customCreateType,
      customCreateError,
      isCreatingField,
    } = this.state;
    const { globals } = this.props;

    const trimmedSearch = customFieldSearch.trim().toLowerCase();
    const displayedFields = trimmedSearch
      ? selectableFields.filter((f) =>
        f.label.toLowerCase().includes(trimmedSearch),
      )
      : selectableFields;

    const CHOICE_TYPES = [
      FIELD_TYPES.DROPDOWN.id,
      FIELD_TYPES.RADIO.id,
      FIELD_TYPES.CHECKBOX.id,
    ];

    const needsOptions = (fieldId) => {
      const field = [...defaultSelectedValue, ...formSelectedValue].find(
        (f) => f.id === fieldId,
      );
      if (field && (field.label || "").toLowerCase() === "course name") {
        return false; // Options are auto-fetched dynamically from DB
      }

      const typeId = parseInt(
        selectedFieldTypes[fieldId] || FIELD_TYPES.TEXT.id,
      );
      return CHOICE_TYPES.includes(typeId);
    };

    return (
      <div className="af-shadcn-card">
        {/* ═══ SECTION 1: Form Details ═══════════════════════════════════ */}
        <div className="af-shadcn-card-header border-bottom">
          <div className="af-form-section-heading mb-0 pb-0 border-0">
            <i className="fas fa-file-alt" /> Form Details
          </div>
          <p className="af-shadcn-card-description mt-1">
            Give this form a name and choose which branch it belongs to.
          </p>
        </div>
        <div className="af-shadcn-card-content pt-4">
          <Form>
            <Form.Row>
              <Form.Group as={Col} lg={3} md={6} sm={12}>
                <label className="af-field-label">Branch *</label>
                {(() => {
                  let authorizedIds = [];
                  try {
                    const cookie = Cookies.get("branch_id");
                    const parsed = cookie ? JSON.parse(cookie) : [];
                    authorizedIds = Array.isArray(parsed) ? parsed : [parsed];
                  } catch (e) {
                    try {
                      const cookie = Cookies.get("branch_id");
                      authorizedIds = cookie ? cookie.split(",").map(id => id.trim()) : [];
                    } catch (err) { console.error(err); }
                  }
                  authorizedIds = authorizedIds.map(String);

                  const authorizedBranches = globals?.globalBranches
                    ?.filter(b => authorizedIds.includes("all") || authorizedIds.includes(String(b.id)));
                  
                  const isSingleBranch = authorizedBranches && authorizedBranches.length === 1;

                  // If branch_id in state is "null" or empty but we have branches, try to pick one
                  const effectiveBranchId = (branch_id === "null" || !branch_id) && authorizedBranches?.length > 0 
                    ? String(authorizedBranches[0].id) 
                    : branch_id;

                  if (isSingleBranch) {
                    return (
                      <div className="d-flex align-items-center py-2 px-3 bg-light rounded border" style={{ gap: "8px", fontSize: "14px", color: "#475569", height: "38px" }}>
                        <i className="fas fa-building text-primary opacity-75" />
                        <strong>Branch:</strong> {authorizedBranches[0].branch_name}
                      </div>
                    );
                  }

                  return (
                    <Form.Control
                      as="select"
                      name="branch_id"
                      value={effectiveBranchId || ""}
                      onChange={this.handleChange}
                      disabled={isDisabled}
                      className={branchError ? "is-invalid" : ""}
                    >
                      <option value="">Select Branch</option>
                      {authorizedBranches?.map((b) => (
                        <option key={b.id} value={b.id}>
                          {b.branch_name}
                        </option>
                      ))}
                    </Form.Control>
                  );
                })()}
                {branchError && !(() => {
                  let auth = [];
                  try { auth = JSON.parse(Cookies.get("branch_id") || "[]"); } catch(e) { auth = (Cookies.get("branch_id") || "").split(",").filter(x => x); }
                  return globals?.globalBranches?.filter(b => auth.includes("all") || auth.includes(String(b.id))).length === 1;
                })() && (
                  <div className="invalid-feedback d-block">{branchError}</div>
                )}
              </Form.Group>

              <Form.Group as={Col} lg={5} md={6} sm={12}>
                <label className="af-field-label">Form Name *</label>
                <Form.Control
                  type="text"
                  name="form_name"
                  value={form_name}
                  onChange={this.handleChange}
                  placeholder="e.g. Registration_Form1, College_Leads..."
                  disabled={isDisabled}
                  className={formNameError ? "is-invalid" : ""}
                  maxLength={80}
                />
                {formNameError ? (
                  <div className="invalid-feedback d-block">
                    {formNameError}
                  </div>
                ) : (
                  <small className="text-muted">
                    3–80 chars. Letters, numbers, spaces, _ and - only.
                  </small>
                )}
              </Form.Group>

              <Col
                lg={4}
                md={12}
                sm={12}
                className="d-flex align-items-center mt-3 mt-lg-0 mb-3"
              >
                <div className="af-form-hint w-100">
                  <i className="fas fa-info-circle" />
                  Name, Mobile, Email, Gender &amp; DOB are always included by
                  default.
                </div>
              </Col>
            </Form.Row>
          </Form>
        </div>

        {/* ═══ SECTION 2: Builder ════════════════════════════════════════ */}
        <div className="af-shadcn-card-content border-top pt-4">
          <div className="af-form-section-heading">
            <i className="fas fa-tools" /> Form Builder
            {formSelectedValue.length > 0 && (
              <span
                className="af-required-badge ml-auto"
                style={{
                  color: "#16a34a",
                  borderColor: "#bbf7d0",
                  background: "#f0fdf4",
                }}
              >
                <i className="fas fa-check-circle mr-1" />
                {formSelectedValue.length} optional field
                {formSelectedValue.length !== 1 ? "s" : ""} added
              </span>
            )}
          </div>
          <p className="text-muted mb-4" style={{ fontSize: 13 }}>
            Pick fields from the left, configure and drag to reorder on the
            right.
          </p>

          <Form.Row className="af-builder-workspace">
            {/* ──────────────────── LEFT PANEL ──────────────────── */}
            <Col
              lg={5}
              className="h-100 mb-4 mb-lg-0 d-flex flex-column"
              style={{ minHeight: 0 }}
            >
              {/* 1. CREATE CUSTOM FIELD — always independent of search */}
              <div className="af-builder-panel mb-3 flex-shrink-0">
                <div className="af-builder-panel-header">
                  <i className="fas fa-plus-circle" /> Create Custom Field
                </div>
                <div className="af-builder-panel-body">
                  <label className="af-field-label">Field Name *</label>
                  <Form.Control
                    type="text"
                    value={customCreateName}
                    onChange={(e) =>
                      this.setState({
                        customCreateName: e.target.value,
                        customCreateError: "",
                      })
                    }
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                        this.handleCreateOrAddField();
                      }
                    }}
                    placeholder="e.g. Pincode, Qualification, Aadhar No..."
                    className={`mb-2 ${customCreateError ? "is-invalid" : ""}`}
                    maxLength={60}
                  />

                  {customCreateError && (
                    <small className="text-danger d-block mb-2">
                      {customCreateError}
                    </small>
                  )}

                  <button
                    type="button"
                    className="af-save-btn w-100"
                    onClick={this.handleCreateOrAddField}
                    disabled={isCreatingField}
                  >
                    {isCreatingField ? (
                      <>
                        <span className="spinner-border spinner-border-sm mr-1" />{" "}
                        Creating...
                      </>
                    ) : (
                      <>
                        <i className="fas fa-plus mr-1" /> Create &amp; Add
                        Field
                      </>
                    )}
                  </button>
                </div>
              </div>

              {/* 2. SEARCH + AVAILABLE FIELDS */}
              <div
                className="af-builder-panel d-flex flex-column"
                style={{ flex: "1 1 0", minHeight: 0 }}
              >
                <div className="af-builder-panel-header">
                  <i className="fas fa-search" /> Available Fields
                  <span
                    className="ml-auto"
                    style={{ fontWeight: 400, color: "#94a3b8" }}
                  >
                    {displayedFields.length} shown
                  </span>
                </div>
                <div className="p-3 pb-0 flex-shrink-0">
                  <Form.Control
                    type="text"
                    placeholder="Filter fields..."
                    value={customFieldSearch}
                    onChange={(e) =>
                      this.setState({ customFieldSearch: e.target.value })
                    }
                    className="mb-0"
                  />
                </div>
                <div
                  className="af-field-list overflow-auto"
                  style={{ flex: "1 1 0", minHeight: 0, padding: 0 }}
                >
                  {displayedFields.length === 0 ? (
                    <div className="af-field-list-empty">
                      {customFieldSearch
                        ? `No fields match "${customFieldSearch}"`
                        : "No additional fields available."}
                    </div>
                  ) : (
                    displayedFields.map((field) => {
                      const isChecked = formSelectedValue.some(
                        (f) => f.id === field.id,
                      );
                      return (
                        <label
                          key={field.id}
                          className={`af-field-list-item${isChecked ? " af-field-list-item--checked" : ""}`}
                        >
                          <input
                            type="checkbox"
                            checked={isChecked}
                            onChange={() => this.toggleField(field)}
                            className="af-field-checkbox"
                          />
                          <span className="af-field-list-name">
                            {field.label}
                          </span>
                          {isChecked && (
                            <i className="fas fa-check-circle af-field-checked-icon" />
                          )}
                        </label>
                      );
                    })
                  )}
                </div>
              </div>
            </Col>

            {/* ──────────────────── RIGHT: CANVAS ──────────────────── */}
            <Col lg={7} className="h-100" style={{ minHeight: 0 }}>
              <div
                className="af-builder-panel h-100 d-flex flex-column"
                style={{ minHeight: 0 }}
              >
                <div className="af-builder-panel-header">
                  <i className="fas fa-eye" /> Live Preview
                  <span
                    className="ml-auto"
                    style={{ fontWeight: 400, color: "#94a3b8" }}
                  >
                    {defaultSelectedValue.length + formSelectedValue.length}{" "}
                    total field
                    {defaultSelectedValue.length + formSelectedValue.length !==
                      1
                      ? "s"
                      : ""}
                  </span>
                </div>
                <div
                  className="af-builder-panel-body overflow-auto"
                  style={{ flex: "1 1 0", minHeight: 0 }}
                >
                  {submitError && (
                    <div
                      className="alert alert-danger py-2 mb-3"
                      style={{ fontSize: 13, borderRadius: 6 }}
                    >
                      <i className="fas fa-exclamation-circle mr-2" />
                      {submitError}
                    </div>
                  )}

                  {defaultSelectedValue.length === 0 &&
                    formSelectedValue.length === 0 ? (
                    <div className="af-preview-card">
                      <div className="text-center py-4">
                        <i
                          className="fas fa-layer-group af-empty-icon"
                          style={{ fontSize: 28 }}
                        />
                        <p
                          className="text-muted mb-0 mt-2"
                          style={{ fontSize: 13 }}
                        >
                          Select fields from the left to build your form.
                        </p>
                      </div>
                    </div>
                  ) : (
                    <div>
                      {/* REQUIRED fields — locked */}
                      {defaultSelectedValue.map((field, i) => {
                        const showOpts = needsOptions(field.id);
                        const opts = selectedFieldOptions[field.id] || [];
                        return (
                          <div
                            key={field.id}
                            className="af-canvas-field af-canvas-field--required"
                          >
                            {/* Row 1: number + name + type + badge */}
                            <div className="af-canvas-field-row">
                              <i className="fas fa-lock af-canvas-lock" />
                              <span className="af-drag-num">{i + 1}</span>
                              <span className="af-canvas-name">
                                {field.label}
                              </span>
                              <div className="af-canvas-field-controls">
                                <Form.Control
                                  as="select"
                                  className="af-mini-select"
                                  value={
                                    selectedFieldTypes[field.id] ||
                                    FIELD_TYPES.TEXT.id
                                  }
                                  onChange={(e) =>
                                    this.handleTypeChange(
                                      field.id,
                                      e.target.value,
                                    )
                                  }
                                  disabled={true}
                                >
                                  {Object.values(FIELD_TYPES).map((t) => (
                                    <option key={t.id} value={t.id}>
                                      {t.label}
                                    </option>
                                  ))}
                                </Form.Control>
                                <span className="af-required-badge">
                                  Required
                                </span>
                              </div>
                            </div>
                            {/* Row 2: options builder  */}
                            {showOpts && (
                              <div className="af-canvas-opts-row">
                                <span className="af-canvas-opts-label">
                                  <i className="fas fa-tags mr-1" /> Options
                                  {opts.length < 2 && (
                                    <span className="af-opts-hint">
                                      {" "}
                                      (min 2 required)
                                    </span>
                                  )}
                                </span>
                                {this.renderOptionsBuilder(field.id)}
                              </div>
                            )}
                          </div>
                        );
                      })}

                      {/* OPTIONAL fields — draggable */}
                      <DragDropContext onDragEnd={this.onDragEnd}>
                        <Droppable droppableId="fields-order">
                          {(provided) => (
                            <div
                              ref={provided.innerRef}
                              {...provided.droppableProps}
                            >
                              {formSelectedValue.map((field, i) => {
                                const showOpts = needsOptions(field.id);
                                const opts =
                                  selectedFieldOptions[field.id] || [];
                                return (
                                  <Draggable
                                    key={field.id}
                                    draggableId={field.id}
                                    index={i}
                                  >
                                    {(provided, snapshot) => (
                                      <div
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        className={`af-canvas-field${snapshot.isDragging ? " af-canvas-field--dragging" : ""}`}
                                      >
                                        {/* Row 1: drag + number + name + type + remove */}
                                        <div className="af-canvas-field-row">
                                          <i
                                            {...provided.dragHandleProps}
                                            className="fas fa-grip-vertical af-canvas-grip"
                                            title="Drag to reorder"
                                          />
                                          <span className="af-drag-num">
                                            {defaultSelectedValue.length +
                                              i +
                                              1}
                                          </span>
                                          <span className="af-canvas-name">
                                            {field.label}
                                          </span>
                                          <div className="af-canvas-field-controls">
                                            <Form.Control
                                              as="select"
                                              className="af-mini-select"
                                              value={
                                                selectedFieldTypes[field.id] ||
                                                FIELD_TYPES.TEXT.id
                                              }
                                              onChange={(e) =>
                                                this.handleTypeChange(
                                                  field.id,
                                                  e.target.value,
                                                )
                                              }
                                            >
                                              {Object.values(FIELD_TYPES).map(
                                                (t) => (
                                                  <option
                                                    key={t.id}
                                                    value={t.id}
                                                  >
                                                    {t.label}
                                                  </option>
                                                ),
                                              )}
                                            </Form.Control>
                                            <button
                                              type="button"
                                              className="af-canvas-remove"
                                              onClick={() =>
                                                this.toggleField(field)
                                              }
                                              title="Remove field"
                                            >
                                              <i className="far fa-trash-alt" />
                                            </button>
                                          </div>
                                        </div>
                                        {/* Row 2: options builder */}
                                        {showOpts && (
                                          <div className="af-canvas-opts-row">
                                            <span className="af-canvas-opts-label">
                                              <i className="fas fa-tags mr-1" />{" "}
                                              Options
                                              {opts.length < 2 && (
                                                <span className="af-opts-hint">
                                                  {" "}
                                                  (min 2 required)
                                                </span>
                                              )}
                                            </span>
                                            {this.renderOptionsBuilder(
                                              field.id,
                                            )}
                                          </div>
                                        )}
                                      </div>
                                    )}
                                  </Draggable>
                                );
                              })}
                              {provided.placeholder}
                            </div>
                          )}
                        </Droppable>
                      </DragDropContext>
                    </div>
                  )}
                </div>
              </div>
            </Col>
          </Form.Row>
        </div>

        {/* ═══ FOOTER ════════════════════════════════════════════════════ */}
        <div className="af-page-footer">
          {submitSuccess && (
            <div className="af-modal-message success">
              <i className="fas fa-check-circle" /> Form saved! Redirecting...
            </div>
          )}
          <button
            type="button"
            className="af-cancel-btn"
            onClick={this.handleCancel}
            disabled={loadingSpinner}
          >
            Cancel
          </button>
          <button
            type="button"
            className="af-save-btn"
            onClick={this.handleSubmit}
            disabled={loadingSpinner || submitSuccess}
          >
            {loadingSpinner && (
              <span className="spinner-border spinner-border-sm mr-2" />
            )}
            {isEditMode ? "Update Form" : "Create Form"}
          </button>
        </div>
      </div>
    );

  }

  render() {
    const { submitSuccess, isEditMode } = this.state;

    return (
      <Container fluid className="px-4 pb-5">
        {/* ── Breadcrumb Navigation ── */}
        <ul className="af-breadcrumb mt-4 px-0">
          <li className="af-bc-item">
            <a
              href="#/admissions-dashboard"
              onClick={(e) => {
                e.preventDefault();
                this.props.history.push("/admissions-dashboard");
              }}
            >
              Admissions
            </a>
          </li>
          <li className="af-bc-item">
            <a
              href="#/admission-forms"
              onClick={(e) => {
                e.preventDefault();
                this.props.history.push("/admission-forms");
              }}
            >
              Forms
            </a>
          </li>
          <li className="af-bc-item active">
            {isEditMode ? "Edit Form" : "Create Form"}
          </li>
        </ul>

        <div
          className="af-admin-header mt-4 mb-4 pb-3 border-bottom d-flex align-items-center"
          style={{ gap: "16px" }}
        >
          <div>
            <h4 className="font-weight-bold mb-1" style={{ color: "#0f172a" }}>
              <i className="fas fa-file-alt mr-2 text-primary opacity-75" />
              {isEditMode ? "Edit Admission Form" : "Create Admission Form"}
            </h4>
            <p className="text-muted mb-0" style={{ fontSize: "14px" }}>
              Configure fields, drag to reorder, then submit.
            </p>
          </div>
        </div>

        {submitSuccess && (
          <div
            className="d-flex align-items-center p-3 mb-4 rounded border"
            style={{
              backgroundColor: "#f0fdf4",
              borderColor: "#86efac",
              color: "#16a34a",
              fontSize: 14,
            }}
          >
            <i className="fas fa-check-circle mr-2" style={{ fontSize: 18 }} />
            Form saved successfully! Redirecting…
          </div>
        )}

        {this.renderPage()}
      </Container>
    );
  }
}

export default withRouter(
  compose(
    graphql(ADD_ENQUIRY_FORM_DETAILS, { name: "manageEnquiryFormFields" }),
  )(withApollo(CreateAdmissionFormPage)),
);
